import { render, staticRenderFns } from "./FreeUserTopOffer.vue?vue&type=template&id=6f9ee184&scoped=true&"
import script from "./FreeUserTopOffer.vue?vue&type=script&lang=js&"
export * from "./FreeUserTopOffer.vue?vue&type=script&lang=js&"
import style0 from "./FreeUserTopOffer.vue?vue&type=style&index=0&id=6f9ee184&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9ee184",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCardTitle, BCardText, BButton, BCardBody, BCard} from 'bootstrap-vue'
    installComponents(component, {BCardTitle, BCardText, BButton, BCardBody, BCard})
    

export default component.exports